export const brandsRoutes = [
  {
    name: 'virtualBrands',
    path: '/virtual-brands',
    component: () => import('@/modules/brands/views/BrandsViewFeatureFlag.vue'),
    meta: {
      locationTypes: ['organization', 'singleLocation']
    }
  },
  {
    name: 'brands',
    path: '/brands',
    component: () => import('@/modules/brands/views/BrandsViewFeatureFlag.vue'),
    meta: {
      locationTypes: ['organization', 'singleLocation']
    }
  },
  {
    name: 'virtualBrand',
    path: '/virtual-brands/:virtualBrandId',
    component: () => import('@/views/VirtualBrand.vue'),
    meta: {
      locationTypes: ['organization', 'singleLocation']
    }
  }
]
